<template>
  <button
    @click.prevent="$emit('click')"
    class="btn btn--primary"
    :class="{'btn--loading': loading}"
  >
    <span
      v-if="loading"
      class="btn__loader"
    >
      <gc-loader/>
    </span>
    <span
      class="btn__text"
      v-text="label"
    />
  </button>
</template>

<script>
  import GcLoader from "./GcLoader";

  export default {
    name: "GcButton",
    components: {GcLoader},
    props: {
      label: {
        default: null
      },
      loading: {
        default: false,
        type: Boolean
      }
    }
  }
</script>

<style>
  .balance-checker .btn {
    position: relative;
    display: inline-block;
    outline: none;
  }

  .balance-checker .btn:hover {
    opacity: .8;
  }

  .balance-checker .btn--loading .btn__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: inherit;
    background: inherit;
  }

  .balance-checker .btn--loading .loader {
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
  }
</style>
